import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { AdminContext } from "../App";

/**
 * Route guard for /settings/*. Access is limited to "admin" and
 * "platform-admin" roles — everyone else is redirected to /ignition.
 */
const AdminGuard = () => {
  const userRole = useContext(AdminContext);
  const isAdmin = userRole === "admin" || userRole === "platform-admin";

  if (!isAdmin) {
    return <Navigate to="/ignition" replace />;
  }

  return <Outlet />;
};

export default AdminGuard;
